import React, { useState } from "react";
import "./App.css";

const GoogleDriveVideo = () => {
  const [play, setPlay] = useState(false);
  const thumbnail = "/img/grupo-cardvideo.jpg";

  return (
    <div className="hero-video-container">
      {!play ? (
        <div
          className="video-thumbnail"
          style={{ backgroundImage: `url(${thumbnail})` }}
          onClick={() => setPlay(true)}
        >
          <div className="play-button"><i class="fa-brands fa-youtube "></i></div>
        </div>
      ) : (
        <iframe
          src="https://drive.google.com/file/d/1ACC_6KP3QUw8YthAeZSSGeEUOWh9zszl/preview"
          title="Amigos do Lixo"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        ></iframe>
      )}
    </div>
  );
};

export default GoogleDriveVideo;
